/**
 * This app's own agent identity.
 *
 * The slug used to live in the main frontend's shared routing module, beside a
 * constant for every other agent — so the platform carried a list of which
 * agents exist, and adding or renaming one meant editing platform code.
 *
 * An agent is an APP plus its config plus its DNS name. Those three already say
 * everything: the agent's manifest (tricorder-agent's store) declares it and its
 * `subdomain:`, DNS points that subdomain here, and this bundle is the UI. The
 * slug is this bundle's own business, so it lives here.
 *
 * It must match the manifest's `slug:` — that is the value the API
 * stamps on sessions and the value GET /config keys the agent's subdomain by.
 * frontend/src/components/agentDetail/agentFaces.test.ts asserts every app
 * module declares its agent identity.
 */
export const AGENT_SLUG = 'patient-admin'
